import _ from "lodash";
import moment from "moment";

const getInvoiceExtraDetails = (invoice) => {
    const invoiceType = invoice.type;
    if (invoiceType === "wallet-deposit") {
        return [
            {
                title: "Wallet Deposit",
                price: invoice.price,
                items: [
                    {
                        title: "Wallet Deposit",
                        price: invoice.price,
                    },
                ],
            },
        ];
    } else if (invoiceType === "education") {
        return [
            {
                title: "Eğitim Paketi",
                price: invoice.price,
                items: [
                    {
                        title: "Eğitim Paketi",
                        price: +(invoice.price / (1 + invoice.vatRate)).toFixed(2),
                    },
                ],
            },
        ];
    } else if (invoiceType === "consultancy") {
        return [
            {
                title: "Danışmanlık Paketi",
                price: invoice.price,
                items: [
                    {
                        title: "Danışmanlık Paketi",
                        price: +(invoice.price / (1 + invoice.vatRate)).toFixed(2),
                    },
                ],
            },
        ];  
    } else if (invoiceType === "installation") {
        return [
            {
                title: "Kurulum Paketi",
                price: invoice.price,
                items: [
                    {
                        title: "Kurulum Paketi",
                        price: +(invoice.price / (1 + invoice.vatRate)).toFixed(2),
                    },
                ],
            },
        ];
    }
};

const extraFields = {
    storage: "Storage",
    "ai-usage": "AI Usage (Base Token Usage)",
    "web-traffic": "Web Site Trafiği",
};

const getInvoiceDetails = (invoice) => {
    if (Object.keys(invoice.details || {}).length === 0) {
        return {
            paid: invoice.paid,
            prices: {
                price: +(invoice.price / (1 + invoice.vatRate)).toFixed(2),
                taxPrice: +(invoice.price * (invoice.vatRate / (1 + invoice.vatRate))).toFixed(2),
                totalPrice: +(invoice.price).toFixed(2),
            },
            period: "",
            plans: getInvoiceExtraDetails(invoice) || [],
        };
    }
    const plans = invoice.details.planActions;
    const timeBuckets = invoice.details.timeBuckets;
    const priceDetail = invoice.details.priceDetail;

    const mergePrice = (oldVal = 0, newVal) => {
        return oldVal + newVal;
    };

    const getChatbotSessionCount = (plan) => {
        const feature = plan.features.find((feature) => feature.type === "chatbot");
        return _.get(feature, "maxSessionCount", 0);
    };
    const bucketMerged = Object.keys(timeBuckets).reduce((acc, planType) => {
        const buckets = timeBuckets[planType];
        buckets.forEach((bucket) => {
            const plan = _.get(plans, `${bucket.planActionId}.target`);
            const planAction = _.get(plans, `${bucket.planActionId}.data`);
            const channelCount =
                _.get(planAction, "details.whatsappChannel") ||
                _.get(planAction, "details.instagramChannel") ||
                _.get(planAction, "details.messengerChannel") ||
                _.get(planAction, "details.trendyolChannel") ||
                _.get(planAction, "details.metaLeadChannel") ||
                _.get(planAction, "details.channelCount");
            const agentCount = _.get(planAction, "details.agentCount", 0);
            const sessionCount = _.get(plan, "type") === "chatbot" ? getChatbotSessionCount(plan) : 0;
            acc[bucket.planActionId || planType] = {
                planType,
                title: plan ? `${plan.title} ${plan.altTitle}` : extraFields[planType],
                isFreePlan: _.get(plan, "isFreePlan", false),
                startDate: _.get(acc[bucket.planActionId], "startDate", bucket.date),
                endDate: bucket.date,
                price: mergePrice(
                    _.get(acc[bucket.planActionId || planType], "price"),
                    _.get(bucket, "details.acceptPrice", _.get(bucket, "details.dailyPrice", 0))
                ),
                details: Object.assign({}, bucket.details, {
                    channelCount: _.get(bucket, "details.channelCount", channelCount),
                    agentCount: _.get(bucket, "details.agentCount", agentCount),
                    totalChatbotSessionCount: _.get(bucket, "details.totalChatbotSessionCount", sessionCount),
                    websiteTrafficCount: _.get(bucket, "details.trafficCount", 0),
                }),
                /*   totalChatbotSessionCount: _.get(bucket, "details.totalChatbotSessionCount", sessionCount),
                   todayUsedSessionCount: mergePrice(
                       _.get(acc[bucket.planActionId || planType], "todayUsedSessionCount"),
                       _.get(bucket, "details.todayUsageSessionCount", 0)
                   ),
                   totalChatbotFreeSessionCount: _.get(bucket, "details.freeSessionCount", 0),
                   todayUsedFreeSessionCount: mergePrice(
                       _.get(acc[bucket.planActionId || planType], "todayUsedFreeSessionCount"),
                       _.get(bucket, "details.todayFreeUsageSessionCount", 0)
                   ),
                   totalChatbotExtraSessionCount: _.get(bucket, "details.extraSessionCount", 0),
                   todayUsedExtraSessionCount: mergePrice(
                       _.get(acc[bucket.planActionId || planType], "todayUsedExtraSessionCount"),
                       _.get(bucket, "details.todayExtraUsageSessionCount", 0)
                   ),*/
            };
        });
        return acc;
    }, {});

    const groups = Object.values(bucketMerged).reduce((acc, bucket) => {
        const key = bucket.planType;
        if (!acc[key]) {
            acc[key] = {
                title: key
                    .split("-")
                    .map((word) => _.capitalize(word))
                    .join(" "),
                price: 0,
                items: [],
            };
        }
        const price = +bucket.price.toFixed(2);
        acc[key].items.push(
            Object.assign({}, bucket, {
                price,
                startDate: bucket.startDate && moment(bucket.startDate).format("MMM DD, YYYY"),
                endDate: bucket.startDate && moment(bucket.endDate).format("MMM DD, YYYY"),
            })
        );
        acc[key].price += price;
        return acc;
    }, {});

    const startDate = moment(invoice.createdDate).format("MMM DD, YYYY");
    const endDate =
        invoice.type === "monthly" ? moment(invoice.createdDate).endOf("month").format(" - MMM DD, YYYY") : "";

    const totalPrice = invoice.price;
    return {
        paid: invoice.paid,
        prices: {   
            price: +(totalPrice / (1 + invoice.vatRate)).toFixed(2),
            taxPrice: +(totalPrice * (invoice.vatRate / (1 + invoice.vatRate))).toFixed(2),
            totalPrice: +totalPrice.toFixed(2),
        },
        period: `${startDate}${endDate}`,
        plans: Object.values(groups).sort((a, b) => b.price - a.price),
    };
};

exports.getDetailInvoice = getInvoiceDetails;


/**
 * "supsis", "chatbot", "customer-tables", "automation", "mail", "tasks", "form", "whatsapp", "whatsapp-business", "instagram", "messenger", "linkedin", "telegram", "meta-lead", "trendyol", "webphone"
 */
const PLAN_TYPES = {
    SUPSIS: "supsis",
    CHATBOT: "chatbot",
    AUTOMATION: "automation",
    CUSTOMER_TABLES: "customer-tables",
    WEB: "web",
    WEBPHONE: "webphone",
    MAIL: "mail",
    TASKS: "tasks",
    FORM: "form",
    WHATSAPP: "whatsapp",
    WHATSAPP_BUSINESS: "whatsapp-business",
    INSTAGRAM: "instagram",
    TELEGRAM: "telegram",
    MESSENGER: "messenger",
    LINKEDIN: "linkedin",
    META_LEAD: "meta-lead",
    TRENDYOL: "trendyol",
};
exports.PLAN_TYPES = PLAN_TYPES;

exports.COUNTABLE_PLAN_TYPES = [
    PLAN_TYPES.SUPSIS,
    PLAN_TYPES.WHATSAPP,
    PLAN_TYPES.WHATSAPP_BUSINESS,
    PLAN_TYPES.INSTAGRAM,
    PLAN_TYPES.TELEGRAM,
    PLAN_TYPES.META_LEAD,
    PLAN_TYPES.LINKEDIN,
    PLAN_TYPES.WEBPHONE,
    PLAN_TYPES.MESSENGER,
    PLAN_TYPES.TRENDYOL,
]

exports.CHANNEL_PLAN_TYPES = [
    PLAN_TYPES.WHATSAPP,
    PLAN_TYPES.WHATSAPP_BUSINESS,
    PLAN_TYPES.INSTAGRAM,
    PLAN_TYPES.TELEGRAM,
    PLAN_TYPES.META_LEAD,
    PLAN_TYPES.LINKEDIN,
    PLAN_TYPES.MESSENGER,
    PLAN_TYPES.TRENDYOL,
    PLAN_TYPES.WEBPHONE,
]

exports.PLAN_DETAILS = {
    [PLAN_TYPES.SUPSIS]: "agentCount",
    [PLAN_TYPES.WHATSAPP]: "whatsappChannel",
    [PLAN_TYPES.WHATSAPP_BUSINESS]: "whatsappChannel",
    [PLAN_TYPES.INSTAGRAM]: "instagramChannel",
    [PLAN_TYPES.TELEGRAM]: "telegramChannel",
    [PLAN_TYPES.META_LEAD]: "metaLeadChannel",
    [PLAN_TYPES.LINKEDIN]: "linkedinChannel",
    [PLAN_TYPES.MESSENGER]: "messengerChannel",
    [PLAN_TYPES.TRENDYOL]: "trendyolChannel",
    [PLAN_TYPES.WEBPHONE]: "channelCount",
    [PLAN_TYPES.MAIL]: "maxUsageCount",
    [PLAN_TYPES.AUTOMATION]: "maxUsageCount",
    [PLAN_TYPES.CUSTOMER_TABLES]: "maxUsageCount",
    [PLAN_TYPES.WEB]: "maxUsageCount",
}